// Chaves do catálogo de BI já existente. A API decide quais estão disponíveis.
export const CONTRACT_REPORT_TABS = [
  { key: 'kpi_solucoes', label: 'KPI Soluções', icon: 'ActivityIcon' },
  { key: 'dash_market_share', label: 'Market Share', icon: 'TrendingUpIcon' },
]

export default CONTRACT_REPORT_TABS
